module.exports = __webpack_public_path__ + "images/dd623b3f75ed6673368dbe58006ca76a.svg";